export const stripNumber = (number, code) => {
  const numberWithNoSpaces = number.replace(/-|\(|\)|\s/g, '');
  return numberWithNoSpaces.replaceAll(`+${code}`, '');
};
